/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Poly8IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Poly8Icon(props: Poly8IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 77 108"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        stroke={"currentColor"}
        strokeLinejoin={"round"}
        strokeWidth={"2"}
        d={
          "m10.19 1 57.567 11.429 8.108 47.714L60.46 95.857 13.972 106.43 1 60.143z"
        }
      ></path>
    </svg>
  );
}

export default Poly8Icon;
/* prettier-ignore-end */
